function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0842bcdc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./bookingRespDashEdit.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./bookingRespDashEdit.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0842bcdc\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bookingRespDashEdit.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0842bcdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/Pricing/bookingRespDashEdit.vue
// module id = 1915
// module chunks = 0